import { z } from '@hono/zod-openapi'
import { rafflesTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertRaffle = z.infer<typeof zInsertRaffle>
export type SelectRaffle = z.infer<typeof zSelectRaffle>
export type UpdateRaffle = z.infer<typeof zUpdateRaffle>
export type QueryRaffles = z.infer<typeof zQueryRaffles>
export type ColumnsOfRafflesTable = keyof typeof rafflesTable._.columns

export const zSelectRaffle = createSelectSchema(rafflesTable)
export const zInsertRaffle = createInsertSchema(rafflesTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateRaffle = zInsertRaffle.partial()
export const zQueryRaffles = zInsertRaffle
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
